module.exports = __webpack_public_path__ + "img/wedding-05.d9de28ef.jpg";